export default {
  fields: {
    discount: {
      label: 'Reducere',
    },
    usage_threshold: {
      label: 'Valoare minimă a comenzii',
    },
    max_discount: {
      label: 'Valoare maximă a reducerii',
    },
  },
};
